<button
  class="quantum-tab-button"
  [ngClass]="active ? 'active' : ''"
  [disabled]="disabled"
>
  {{ title }}
</button>
